import { CompanyFormSchema } from "@/schemas/company-form.schema";
import { cbHttp } from "./http.service";
import { z } from "zod";
import { CompanySchema } from "@/schemas/company.schema";
import { DomainSchema } from "@/schemas/domain.schema";


export const addCompany = async (data: z.infer<typeof CompanyFormSchema>): Promise<z.infer<typeof CompanySchema>> => {
    return cbHttp.post('/api/companies', data);
}

export const getCompanies = async (): Promise<z.infer<typeof CompanySchema>[]> => {
    return cbHttp.get('/api/companies');
}

export const getCompanyById = async (id: string): Promise<z.infer<typeof CompanySchema>> => {
    return cbHttp.get(`/api/companies/${id}`);
}

export const getCompanyDomains = async (companyId: string): Promise<z.infer<typeof DomainSchema>[]> => {
    return cbHttp.get(`/api/companies/domains/${companyId}`);
}